<template>
  <div>
    <van-tabbar fixed placeholder>
      <van-button class="b0" v-if="b0" @click="$emit('b0c')" :round="gBtnRound()">
        {{ b0 }}
      </van-button>
      <van-button v-if="b1" @click="$emit('b1c')" :disabled="!anime" :round="gBtnRound()">
        <span
          v-if="anime && !sGetConfig('chkDisableAnimate')"
          class="animate__animated animate__flash animate__infinite animate__slower"
        >
          {{ b1 }}
        </span>
        <span v-else>{{ b1 }}</span>
      </van-button>
    </van-tabbar>
  </div>
</template>

<style scoped>
.van-tabbar {
  z-index: 3;
}
.back {
  font-size: 2rem;
}
.van-popup {
  width: 100%;
  height: 100%;
}
.van-button {
  background-color: v-bind(sGetConfig("color3"));
  color: white;
  /* border-radius: 2rem; */
  margin: 6px;
  width: 100%;
  height: 44px;
  font-size: 1rem;
  z-index: 2;
}
.b0 {
  background-color: grey;
}
</style>
<script>
export default {
  props: {
    b0: String,
    b1: String,
    anime: Boolean,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
